import { render, staticRenderFns } from "./PartWaterQualityLastRecordModal.vue?vue&type=template&id=8bafc854&scoped=true"
import script from "./PartWaterQualityLastRecordModal.vue?vue&type=script&lang=js"
export * from "./PartWaterQualityLastRecordModal.vue?vue&type=script&lang=js"
import style0 from "./PartWaterQualityLastRecordModal.vue?vue&type=style&index=0&id=8bafc854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bafc854",
  null
  
)

export default component.exports